import React, { Component, Fragment } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';

class Footer extends Component {
render () { 
    return (
        <Fragment>
            <Box className="footer" sx={{p: 4, width: '100%', bgcolor: '#00456C', color:'#ffffff' }}>
            <Grid container spacing={8} justify="center">
                <Grid item  xs={12} sm={6} md={6} >
                    © 2021 NTS
                    </Grid>    
                    <Grid item  xs={12} sm={6} md={6} >
                    <a href="https://www.nts.eu/" target="_blank">www.nts.eu</a>
                    </Grid> 
            </Grid>
            </Box>
        </Fragment>

    );
    }
}

export default Footer
